<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
      <div class="card">
        <div class="title mb-3">{{ $t('forecasted-reservation') }}</div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('from-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart6.from_date_modal_id"
                ref="chart6_from_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart6.from_date"
                  @context="(ctx) => (chart6.from_date_context = ctx)"
                  @input="$refs.chart6_from_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart6.from_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart6.from_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart6.from_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('to-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart6.to_date_modal_id"
                ref="chart6_to_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart6.to_date"
                  @context="(ctx) => (chart6.to_date_context = ctx)"
                  @input="$refs.chart6_to_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart6.to_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart6.to_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart6.to_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
            <div
              class="error-text"
              v-if="
                chart6.from_date && chart6.to_date && !validToDate(chart6.from_date, chart6.to_date)
              "
            >
              {{ $t('to-date-error-msg') }}
            </div>
          </div>
        </div>
        <div
          v-if="chart6.loading"
          class="d-flex align-items-center justify-content-center map-center-content"
        >
          <base-spinner></base-spinner>
        </div>
        <div v-else-if="chart6.error && chart6.error.length" class="map-center-content">
          <b-alert :show="chart6.error && chart6.error.length ? true : false" variant="danger">
            <div v-html="chart6.error || '&nbsp;'"></div>
          </b-alert>
        </div>
        <div
          v-else-if="
            chart6 &&
            chart6.from_date &&
            chart6.to_date &&
            validToDate(chart6.from_date, chart6.to_date) &&
            chart6.data &&
            chart6.options
          "
        >
          <LineChart height="300px" :data="chart6.data" :options="chart6.options" />
        </div>
        <div v-else class="map-center-content range-text">
          {{ $t('select-correct-dates-msg') }}
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
      <div class="card">
        <div class="title mb-3">{{ $t('collection-report') }}</div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('from-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart3.from_date_modal_id"
                ref="chart3_from_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart3.from_date"
                  @context="(ctx) => (chart3.from_date_context = ctx)"
                  @input="$refs.chart3_from_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart3.from_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart3.from_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart3.from_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('to-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart3.to_date_modal_id"
                ref="chart3_to_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart3.to_date"
                  @context="(ctx) => (chart3.to_date_context = ctx)"
                  @input="$refs.chart3_to_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart3.to_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart3.to_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart3.to_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
            <div
              class="error-text"
              v-if="
                chart3.from_date && chart3.to_date && !validToDate(chart3.from_date, chart3.to_date)
              "
            >
              {{ $t('to-date-error-msg') }}
            </div>
          </div>
        </div>
        <div
          v-if="chart3.loading"
          class="d-flex align-items-center justify-content-center map-center-content"
        >
          <base-spinner></base-spinner>
        </div>
        <div v-else-if="chart3.error && chart3.error.length" class="map-center-content">
          <b-alert :show="chart3.error && chart3.error.length ? true : false" variant="danger">
            <div v-html="chart3.error || '&nbsp;'"></div>
          </b-alert>
        </div>
        <div
          v-else-if="
            chart3 &&
            chart3.from_date &&
            chart3.to_date &&
            validToDate(chart3.from_date, chart3.to_date) &&
            chart3.data &&
            chart3.options
          "
        >
          <Bar height="300px" :data="chart3.data" :options="chart3.options" />
        </div>
        <div v-else class="map-center-content range-text">
          {{ $t('select-correct-dates-msg') }}
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
      <div class="card">
        <div class="title mb-3">{{ $t('collection-forecasting') }}</div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('from-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart4.from_date_modal_id"
                ref="chart4_from_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart4.from_date"
                  @context="(ctx) => (chart4.from_date_context = ctx)"
                  @input="$refs.chart4_from_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart4.from_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart4.from_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart4.from_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('to-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart4.to_date_modal_id"
                ref="chart4_to_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart4.to_date"
                  @context="(ctx) => (chart4.to_date_context = ctx)"
                  @input="$refs.chart4_to_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart4.to_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart4.to_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart4.to_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
            <div
              class="error-text"
              v-if="
                chart4.from_date && chart4.to_date && !validToDate(chart4.from_date, chart4.to_date)
              "
            >
              {{ $t('to-date-error-msg') }}
            </div>
          </div>
        </div>
        <div
          v-if="chart4.loading"
          class="d-flex align-items-center justify-content-center map-center-content"
        >
          <base-spinner></base-spinner>
        </div>
        <div v-else-if="chart4.error && chart4.error.length" class="map-center-content">
          <b-alert :show="chart4.error && chart4.error.length ? true : false" variant="danger">
            <div v-html="chart4.error || '&nbsp;'"></div>
          </b-alert>
        </div>
        <div
          v-else-if="
            chart4 &&
            chart4.from_date &&
            chart4.to_date &&
            validToDate(chart4.from_date, chart4.to_date) &&
            chart4.data &&
            chart4.options
          "
        >
          <Bar height="300px" :data="chart4.data" :options="chart4.options" />
        </div>
        <div v-else class="map-center-content range-text">
          {{ $t('select-correct-dates-msg') }}
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
      <div class="card">
        <div class="title mb-3">
          {{ $t('collection-rates-from-full-Amount') }}
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('from-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart5.from_date_modal_id"
                ref="chart5_from_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart5.from_date"
                  @context="(ctx) => (chart5.from_date_context = ctx)"
                  @input="$refs.chart5_from_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart5.from_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart5.from_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart5.from_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
            <div class="form-label label-text">{{ $t('to-date') }}</div>
            <div class="input-group">
              <b-modal
                :id="chart5.to_date_modal_id"
                ref="chart5_to_date_modal_id"
                centered
                hide-header
                hide-footer
                no-fade
                static
                content-class="w-auto mx-auto"
              >
                <b-calendar
                  v-model="chart5.to_date"
                  @context="(ctx) => (chart5.to_date_context = ctx)"
                  @input="$refs.chart5_to_date_modal_id.hide()"
                >
                </b-calendar>
              </b-modal>
              <b-input-group v-b-modal="chart5.to_date_modal_id">
                <label
                  class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                >
                  <span v-if="!chart5.to_date_context.selectedYMD" class="time-placeHolder">{{
                    $t('select-date')
                  }}</span>
                  {{ chart5.to_date_context.selectedYMD }}
                  <img :src="require(`@/assets/images/icons/select-time.svg`)" alt="select time" />
                </label>
              </b-input-group>
            </div>
            <div
              class="error-text"
              v-if="
                chart5.from_date && chart5.to_date && !validToDate(chart5.from_date, chart5.to_date)
              "
            >
              {{ $t('to-date-error-msg') }}
            </div>
          </div>
        </div>
        <div
          v-if="chart5.loading"
          class="d-flex align-items-center justify-content-center map-center-content"
        >
          <base-spinner></base-spinner>
        </div>
        <div v-else-if="chart5.error && chart5.error.length" class="map-center-content">
          <b-alert :show="chart5.error && chart5.error.length ? true : false" variant="danger">
            <div v-html="chart5.error || '&nbsp;'"></div>
          </b-alert>
        </div>
        <div
          v-else-if="
            chart5 &&
            chart5.from_date &&
            chart5.to_date &&
            validToDate(chart5.from_date, chart5.to_date) &&
            chart5.data &&
            chart5.options
          "
        >
          <Pie height="300px" :data="chart5.data" :options="chart5.options" />
        </div>
        <div v-else class="map-center-content range-text">
          {{ $t('select-correct-dates-msg') }}
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
      <div class="card">
        <div class="title mb-3">{{ $t('trips') }}</div>
        <div
          v-if="chart2.loading"
          class="d-flex align-items-center justify-content-center map-center-content"
        >
          <base-spinner></base-spinner>
        </div>
        <div v-else-if="chart2.error && chart2.error.length" class="map-center-content">
          <b-alert :show="chart2.error && chart2.error.length ? true : false" variant="danger">
            <div v-html="chart2.error || '&nbsp;'"></div>
          </b-alert>
        </div>
        <div v-else-if="chart2.data && chart2.options">
          <Pie height="375px" :data="chart2.data" :options="chart2.options" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'underscore'
import { Pie, Bar, Line as LineChart } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  PointElement,
  LineElement,
} from 'chart.js'
import TripService from '@/services/trip.service'
import FinancialReportsService from '@/services/financial-reports.service'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement
)

export default {
  name: 'Charts',
  components: { Pie, Bar, LineChart },
  data() {
    return {
      chart2: {
        loading: false,
        error: null,
        options: null,
        data: null,
      },
      chart3: {
        loading: false,
        error: null,
        from_date: this.$store.getters['dashboard/chart3']?.from_date,
        to_date: this.$store.getters['dashboard/chart3']?.to_date,
        from_date_modal_id: 'chart3_from_date_modal_id',
        from_date_context: {},
        to_date_modal_id: 'chart3_to_date_modal_id',
        to_date_context: {},
      },
      chart4: {
        loading: false,
        error: null,
        from_date: this.$store.getters['dashboard/chart4']?.from_date,
        to_date: this.$store.getters['dashboard/chart4']?.to_date,
        from_date_modal_id: 'chart4_from_date_modal_id',
        from_date_context: {},
        to_date_modal_id: 'chart4_to_date_modal_id',
        to_date_context: {},
      },
      chart5: {
        loading: false,
        error: null,
        from_date: this.$store.getters['dashboard/chart5']?.from_date,
        to_date: this.$store.getters['dashboard/chart5']?.to_date,
        from_date_modal_id: 'chart5_from_date_modal_id',
        from_date_context: {},
        to_date_modal_id: 'chart5_to_date_modal_id',
        to_date_context: {},
      },
      chart6: {
        loading: false,
        error: null,
        from_date: this.$store.getters['dashboard/chart6']?.from_date,
        to_date: this.$store.getters['dashboard/chart6']?.to_date,
        from_date_modal_id: 'chart6_from_date_modal_id',
        from_date_context: {},
        to_date_modal_id: 'chart6_to_date_modal_id',
        to_date_context: {},
      },
    }
  },
  methods: {
    setValueChart3(val, field) {
      this['chart3'][field] = val
    },
    setValueChart4(val, field) {
      this['chart4'][field] = val
    },
    setValueChart5(val, field) {
      this['chart5'][field] = val
    },
    setValueChart6(val, field) {
      this['chart6'][field] = val
    },
    validToDate(from_date, to_date) {
      if (from_date && to_date) {
        const a = moment(from_date).set('hour', 0).set('minute', 0).set('seconds', 0)
        const b = moment(to_date).set('hour', 0).set('minute', 0).set('seconds', 0)
        // const day = a.diff(b, "days");

        // return day < 0;
        return a.isSameOrBefore(b)
      } else return true
    },
    setChart2() {
      this.chart2.loading = true
      TripService.get('status-aggregate')
        .then(({ tripsStatusAggregate }) => {
          const totalBookingConfirmed = tripsStatusAggregate['Booking-Confirmed']
          const totalBookingReAssigned = tripsStatusAggregate['Booking-Re-Assigned']
          const totalBookingUnAssigned = tripsStatusAggregate['Booking-Un-Assigned']
          const totalBookingPending = tripsStatusAggregate['Booking-Pending']
          const totalBookingCancelled = tripsStatusAggregate['Booking-Cancelled']
          const totalBookingCancelledNote = tripsStatusAggregate['Booking-Cancelled-Note']
          const totalTripStarted = tripsStatusAggregate['Trip-Started']
          const totalTripArrivedAtPickupLocation =
            tripsStatusAggregate['Trip-Arrived-At-Pickup-Location']
          const totalTripPassengerPickedUp = tripsStatusAggregate['Trip-Passenger-Picked-Up']
          const totalTripArrivedToDroppedOff = tripsStatusAggregate['Trip-Arrived-To-Dropped-Off']
          const totalTripPassengerDroppedOff = tripsStatusAggregate['Trip-Passenger-Dropped-Off']
          const totalTripCompleted = tripsStatusAggregate['Trip-Completed']
          const totalTripCompletedNote = tripsStatusAggregate['Trip-Completed-Note']

          this.chart2.options = {
            legend: {
              position: 'left',
              labels: {
                fontColor: 'black',
                fontSize: 20,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
          }
          this.chart2.data = {
            labels: [
              `${this.$t('Booking-Confirmed')}: ${totalBookingConfirmed}`,
              `${this.$t('Booking-Re-Assigned')}: ${totalBookingReAssigned}`,
              `${this.$t('Booking-Un-Assigned')}: ${totalBookingUnAssigned}`,
              `${this.$t('Booking-Pending')}: ${totalBookingPending}`,
              `${this.$t('Booking-Cancelled')}: ${totalBookingCancelled}`,
              `${this.$t('Booking-Cancelled-Note')}: ${totalBookingCancelledNote}`,
              `${this.$t('Trip-Started')}: ${totalTripStarted}`,
              `${this.$t('Trip-Arrived-At-Pickup-Location')}: ${totalTripArrivedAtPickupLocation}`,
              // `${this.$t(
              //   "Trip-Passenger-Picked-Up"
              // )}: ${totalTripPassengerPickedUp}`,
              `${this.$t('Trip-Arrived-To-Dropped-Off')}: ${totalTripArrivedToDroppedOff}`,
              // `${this.$t(
              //   "Trip-Passenger-Dropped-Off"
              // )}: ${totalTripPassengerDroppedOff}`,
              `${this.$t('Trip-Completed')}: ${totalTripCompleted}`,
              `${this.$t('Trip-Completed-Note')}: ${totalTripCompletedNote}`,
            ],
            datasets: [
              {
                label: ['Journeys'],
                backgroundColor: [
                  '#ffcd56',
                  '#37a2eb',
                  '#4cc0c0',
                  '#ff6383',
                  '#fcc385',
                  '#4cf0c0',
                  '#D6D6D6',
                  '#E4D8C2',
                  '#CEEEDA',
                  '#F7DDD7',
                  '#E9A595',
                  '#FFBA68',
                ],
                data: [
                  totalBookingConfirmed,
                  totalBookingReAssigned,
                  totalBookingUnAssigned,
                  totalBookingPending,
                  totalBookingCancelled,
                  totalBookingCancelledNote,
                  totalTripStarted,
                  totalTripArrivedAtPickupLocation,
                  totalTripPassengerPickedUp,
                  totalTripArrivedToDroppedOff,
                  totalTripPassengerDroppedOff,
                  totalTripCompleted,
                  totalTripCompletedNote,
                ],
              },
            ],
          }
        })
        .catch(({ message }) => {
          this.chart2.error = message
        })
        .finally(() => {
          this.chart2.loading = false
        })
    },
    setChart3() {
      this.chart3.loading = true
      this.chart3.error = null

      this.$store
        .dispatch('dashboard/ADD_CHART3_VALUES', {
          from_date: this?.chart3?.from_date,
          to_date: this?.chart3?.to_date,
        })
        .then(() => {
          FinancialReportsService.post(
            {
              fromDate: moment(this?.chart3?.from_date).locale('en').format('YYYY-MM-DD'),
              toDate: moment(this?.chart3?.to_date).locale('en').format('YYYY-MM-DD'),
              type: 'collection-report',
            },
            'create'
          )
            .then((records) => {
              let dateLabel = [],
                dataset = [],
                data = []
              const items = records.sort(function (a, b) {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
              })
              const groupedByMonth = _.groupBy(items, function (item) {
                return item.date.substring(0, 7)
              })

              if (Object.keys(groupedByMonth).length > 1) {
                for (let i = 0; i < Object.keys(groupedByMonth).length; i++) {
                  const key = Object.keys(groupedByMonth)[i]
                  dateLabel.push(key)
                  if (groupedByMonth[key].length) {
                    let sum = 0
                    for (let j = 0; j < groupedByMonth[key].length; j++) {
                      const element = groupedByMonth[key][j]
                      sum += element.paidBalance
                    }
                    data.push(sum)
                  }
                }
              } else {
                items?.map((item) => {
                  dateLabel.push(item.date)
                  data.push(item.paidBalance)
                })
              }

              dataset.push({
                label: this.$t('paid-balance'),
                backgroundColor: '#37a2eb',
                data: data,
              })

              this.chart3.options = {
                responsive: true,
                maintainAspectRatio: false,
              }
              this.chart3.data = {
                labels: dateLabel,
                datasets: dataset,
              }
            })
            .catch(({ message }) => {
              this.chart3.error = message
            })
            .finally(() => {
              this.chart3.loading = false
            })
        })
    },
    setChart4() {
      this.chart4.loading = true
      this.chart4.error = null

      this.$store
        .dispatch('dashboard/ADD_CHART4_VALUES', {
          from_date: this?.chart4?.from_date,
          to_date: this?.chart4?.to_date,
        })
        .then(() => {
          FinancialReportsService.post(
            {
              fromDate: moment(this?.chart4?.from_date).locale('en').format('YYYY-MM-DD'),
              toDate: moment(this?.chart4?.to_date).locale('en').format('YYYY-MM-DD'),
              type: 'collection-report',
            },
            'create'
          )
            .then((records) => {
              let dateLabel = [],
                dataset = [],
                data = []
              const items = records.sort(function (a, b) {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
              })
              const groupedByMonth = _.groupBy(items, function (item) {
                return item.date.substring(0, 7)
              })

              if (Object.keys(groupedByMonth).length > 1) {
                for (let i = 0; i < Object.keys(groupedByMonth).length; i++) {
                  const key = Object.keys(groupedByMonth)[i]
                  dateLabel.push(key)
                  if (groupedByMonth[key].length) {
                    let sum = 0
                    for (let j = 0; j < groupedByMonth[key].length; j++) {
                      const element = groupedByMonth[key][j]
                      sum += element.outstandingBalance
                    }
                    data.push(sum)
                  }
                }
              } else {
                items?.map((item) => {
                  dateLabel.push(item.date)
                  data.push(item.outstandingBalance)
                })
              }

              dataset.push({
                label: this.$t('outstanding-balance'),
                backgroundColor: '#37a2eb',
                data: data,
              })

              this.chart4.options = {
                responsive: true,
                maintainAspectRatio: false,
              }
              this.chart4.data = {
                labels: dateLabel,
                datasets: dataset,
              }
            })
            .catch(({ message }) => {
              this.chart4.error = message
            })
            .finally(() => {
              this.chart4.loading = false
            })
        })
    },
    setChart5() {
      this.chart5.loading = true
      this.chart5.error = null

      this.$store
        .dispatch('dashboard/ADD_CHART5_VALUES', {
          from_date: this?.chart5?.from_date,
          to_date: this?.chart5?.to_date,
        })
        .then(() => {
          FinancialReportsService.post(
            {
              fromDate: moment(this?.chart5?.from_date).locale('en').format('YYYY-MM-DD'),
              toDate: moment(this?.chart5?.to_date).locale('en').format('YYYY-MM-DD'),
              type: 'collection-report',
            },
            'create'
          )
            .then((items) => {
              let dataset = [],
                totalPaidBalance = 0,
                totalOutstandingBalance = 0

              for (let i = 0; i < items.length; i++) {
                const item = items[i]
                totalPaidBalance += item.paidBalance
                totalOutstandingBalance += item.outstandingBalance
              }

              dataset.push({
                label: this.$t('amount'),
                backgroundColor: ['#37a2eb', '#ff6383'],
                data: [totalPaidBalance, totalOutstandingBalance],
              })

              this.chart5.options = {
                responsive: true,
                maintainAspectRatio: false,
              }
              this.chart5.data = {
                labels: [
                  `${this.$t('paid-balance')}: ${Math.round(totalPaidBalance * 10000) / 10000}`,
                  `${this.$t('outstanding-balance')}: ${
                    Math.round(totalOutstandingBalance * 10000) / 10000
                  }`,
                ],
                datasets: dataset,
              }
            })
            .catch(({ message }) => {
              this.chart5.error = message
            })
            .finally(() => {
              this.chart5.loading = false
            })
        })
    },
    setChart6() {
      this.chart6.loading = true
      this.chart6.error = null

      this.$store
        .dispatch('dashboard/ADD_CHART6_VALUES', {
          from_date: this?.chart6?.from_date,
          to_date: this?.chart6?.to_date,
        })
        .then(() => {
          FinancialReportsService.post(
            {
              fromDate: moment(this?.chart6?.from_date).locale('en').format('YYYY-MM-DD'),
              toDate: moment(this?.chart6?.to_date).locale('en').format('YYYY-MM-DD'),
              type: 'forecast-availability',
            },
            'create'
          )
            .then(({ data }) => {
              let dateLabel = [],
                dataset = [],
                data1 = [],
                data2 = []
              const items = data.sort(function (a, b) {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
              })

              items?.map((item) => {
                dateLabel.push(item.date)
                data1.push(item.totalAvailableSlots)
                data2.push(item.totalReservedSlots)
              })

              dataset.push(
                {
                  label: this.$t('available-slots'),
                  backgroundColor: 'green',
                  data: data1,
                },
                {
                  label: this.$t('reserved-slots'),
                  backgroundColor: 'red',
                  data: data2,
                }
              )

              this.chart6.options = {
                responsive: true,
                maintainAspectRatio: false,
                onClick: (point, event) => {
                  if (
                    event &&
                    event.length &&
                    dateLabel &&
                    dateLabel.length &&
                    dateLabel[event[0].index]
                  )
                    this.$router
                      .push(`/operations/calendar?date=${dateLabel[event[0].index]}`)
                      .catch(() => {})
                },
              }
              this.chart6.data = {
                labels: dateLabel,
                datasets: dataset,
              }
            })
            .catch(({ message }) => {
              this.chart6.error = message
            })
            .finally(() => {
              this.chart6.loading = false
            })
        })
    },
  },
  watch: {
    'chart3.from_date': {
      deep: true,
      handler(val) {
        if (val && this.chart3.to_date && this.validToDate(val, this.chart3.to_date))
          this.setChart3()
      },
    },
    'chart3.to_date': {
      deep: true,
      handler(val) {
        if (this.chart3.from_date && val && this.validToDate(this.chart3.from_date, val))
          this.setChart3()
      },
    },
    'chart4.from_date': {
      deep: true,
      handler(val) {
        if (val && this.chart4.to_date && this.validToDate(val, this.chart4.to_date))
          this.setChart4()
      },
    },
    'chart4.to_date': {
      deep: true,
      handler(val) {
        if (this.chart4.from_date && val && this.validToDate(this.chart4.from_date, val))
          this.setChart4()
      },
    },
    'chart5.from_date': {
      deep: true,
      handler(val) {
        if (val && this.chart5.to_date && this.validToDate(val, this.chart5.to_date))
          this.setChart5()
      },
    },
    'chart5.to_date': {
      deep: true,
      handler(val) {
        if (this.chart5.from_date && val && this.validToDate(this.chart5.from_date, val))
          this.setChart5()
      },
    },
    'chart6.from_date': {
      deep: true,
      handler(val) {
        if (val && this.chart6.to_date && this.validToDate(val, this.chart6.to_date))
          this.setChart6()
      },
    },
    'chart6.to_date': {
      deep: true,
      handler(val) {
        if (this.chart6.from_date && val && this.validToDate(this.chart6.from_date, val))
          this.setChart6()
      },
    },
  },
  async mounted() {
    await this.setChart2()
    if (
      this.chart3.from_date &&
      this.chart3.to_date &&
      this.validToDate(this.chart3.from_date, this.chart3.to_date)
    )
      this.setChart3()
    if (
      this.chart4.from_date &&
      this.chart4.to_date &&
      this.validToDate(this.chart4.from_date, this.chart4.to_date)
    )
      this.setChart4()
    if (
      this.chart5.from_date &&
      this.chart5.to_date &&
      this.validToDate(this.chart5.from_date, this.chart5.to_date)
    )
      this.setChart5()
    if (
      this.chart6.from_date &&
      this.chart6.to_date &&
      this.validToDate(this.chart6.from_date, this.chart6.to_date)
    )
      this.setChart6()
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/dashboard.json'),
      ar: require('@/services/i18n/locales/ar/dashboard.json'),
    },
  },
}
</script>

<style lang="scss">
.card {
  padding: 16px;
}
.title {
  font-size: 20px;
  color: var(--color-17);
  font-weight: 600;
}
.map-center-content {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.range-text {
  font-size: 16px;
  color: var(--color-17);
  font-weight: 600;
}
</style>
